$(function () {
    /*
    Global function calls
     */
   picturefill();
   svg4everybody();
   
   new window.RFDS.Components.DonationShow();
});
